import { Box, Text, Avatar, Spacer } from '@chakra-ui/react';
import shallow from 'zustand/shallow';

import { useAuth } from '../../lib/auth-provider/context';

import backgroundImage from '../../assets/images/Graphic Side.png';

function ProfileHeader({ action }) {
  const [user] = useAuth((state) => [state.user], shallow);
  const { role, fullname } = user;

  return (
    <Box bgImage={`url('${backgroundImage}')`}>
      <Box
        px="40px"
        py="52px"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        textColor="white"
      >
        <Text fontSize="2xl" as="b">
          Hello, {fullname} !
        </Text>
        <Text>We are on a mission to help school ...</Text>
      </Box>
      <Box
        bgColor="white"
        px="24px"
        py="24px"
        borderTopRadius="8px"
        display="flex"
        flexDir={{ base: 'column', md: 'row' }}
        alignItems="center"
        gap="6px"
      >
        <Avatar
          width="100px"
          height="100px"
          mt="-58px"
          name={fullname}
          src="https://bisabucket.s3.ap-southeast-1.amazonaws.com/ombagus.jpeg"
        />
        <Box display="flex" alignItems="center">
          <Text mr="6px" fontSize="xl">
            {fullname}
          </Text>
          <Text color="gray">- {role}</Text>
        </Box>
        <Spacer />
        {action}
      </Box>
    </Box>
  );
}

export default ProfileHeader;
